PJQ.views.settings.TimeCardSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Time-Card-Settings')
    },
    events: {
        'change .cb-enable-line-items': 'render',
        'change .cb-enable-clock-in': 'enableClockInChanged',
        'click .add-timecard-category': 'addCategory',
        'click .btn-save-category': 'saveCategory',
        'click .btn-edit-category': 'editCategory',
        'click .btn-cancel-edit-category': 'cancelEditCategory',
        'click .btn-delete-category': 'deleteCategory'
    },
    beforeFirstRender: function () {
        if (typeof this.options.onChange === 'function') {
            this.listenTo(this.model, 'change', function () {
                this.options.onChange(this.model);
            });
        }

        this.isFetched = false;
        PJQ.app.session.fetchCostTypes((costTypes) => {
            this.costTypes = costTypes;
            this.isFetched = true;
            this.render();
        })
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.renderCategoryTable();

        new PJQ.inputs.Selectpicker({
            el: this.$('.week-start'),
            isIntChoices: true,
            defaultValue: this.model.get('weekStart'),
            onChange: _.bind(function (value) {
                this.model.set('weekStart', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-cost-type'),
            isIntChoices: true,
            defaultValue: this.model.get('defaultCostTypeId'),
            choices: _.map(this.costTypes.models, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                }
            }),
            onChange: _.bind(function (value) {
                this.model.set('defaultCostTypeId', value);
            }, this)
        });
    },
    renderCategoryTable: function () {
        this.categoryContext = null;
        if (this.model.get('enableLineItems')) {
            return
        }

        this.categoryDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".time-card-categories"),
            data: this.options.categories.models,
            isHideSearch: true,
            targets: 'no-sort',
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add Category" to create a new Category'
            },
            bSort: false,
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.categoryContext != null && this.categoryContext.id === row.id) {
                                return '<input type="text" class="form-control input-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Category",
                    "orderable": false
                },
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "visible": false
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '70px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '';
                        if (this.categoryContext != null && this.categoryContext.id === row.id) {
                            buttons = '<button type="button" class="btn btn-success btn-save-category wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-category wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            buttons += '<button type="button" class="btn btn-info btn-edit-category wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
                            buttons += '<button type="button" class="btn btn-danger btn-delete-category wd-30p"><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="show-on-row-hover text-align-right">' + buttons + '</div>'
                    }, this)
                }
            ],
        });
    },
    enableClockInChanged: function (e) {
        let enabled = $(e.currentTarget).prop('checked');
        if (enabled) {
            this.model.set({
                enableOvertime: false,
                enableDoubletime: false
            });
        }
        this.render();
    },
    addCategory: function () {
        let newCategory = new PJQ.models.timecards.TimeCardCategory({
            name: "",
            sortOrder: this.options.categories.length + 1
        });
        this.options.categories.add(newCategory);
        this.categoryContext = newCategory;
        this.categoryDataTable.addRow(newCategory);
    },
    editCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data();
        this.categoryContext = category;
        this.categoryDataTable.render();
    },
    saveCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data(),
            $name = $row.find('.input-name');
        category.set('name', $name.val());
        category.set('sortOrder', category.attributes.sortOrder);

        let isNameValid = _.size(category.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        if (isNameValid) {
            category.save(null, {
                success: _.bind(function () {
                    this.categoryContext = null;
                    this.categoryDataTable.render();
                }, this)
            });
        }
    },
    cancelEditCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data();

        new PJQ.views.modals.YesNo({
            header: "Cancel " + (category.isNew() ? "Add" : "Edit"),
            body: "Do you want to cancel " + (category.isNew() ? 'adding' : 'editing') + " this Category?",
            onYes: _.bind(function () {
                if (category.isNew()) {
                    this.options.categories.remove([category]);
                }

                this.categoryContext = null;
                this.categoryDataTable.render();
            }, this)
        });
    },
    deleteCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data();

        new PJQ.views.modals.YesNo({
            header: "Delete Category",
            body: "Do you want to delete this Category?",
            onYes: _.bind(function () {
                category.destroy({
                    success: _.bind(function () {
                        this.options.categories.remove([category]);
                        this.categoryDataTable.render();
                    }, this)
                });
            }, this)
        });
    }
});
